import React from "react";
import { useTranslation } from "../../context/TranslationContext";
const Description = ({ title, icerik }) => {
  const { discover } = useTranslation();
  return (
    <div className="w-full lg:mt-6 relative px-5 sm:px-[1.3rem] lg:px-0 bg-bg-Description-bg lg:bg-none">
      <div className="pt-12 lg:pl-8 flex flex-col pb-32 bg-bg-Description-bg before:content-[''] before:h-full before:bg-bg-Description-bg before:absolute before:w-full before:-left-full before:top-0 after:content-[''] after:h-full after:bg-bg-Description-bg after:absolute after:w-full after:-right-full after:top-0">
        <span className="font-medium text-13  tracking-5">{title}</span>
        <span className="font-bold text-[22px] -mt-1 lg:text-lg text-orange">
          {discover}
        </span>
        <div
          className="text-sm opacity-75 mt-6 text-brand-black leading-[23px]"
          dangerouslySetInnerHTML={{ __html: icerik }}
        ></div>
      </div>
    </div>
  );
};

export default Description;
